export default {"src":"/_next/static/media/feature_3.3040bcd7.svg","height":93,"width":85,"blurWidth":0,"blurHeight":0};